import { render, staticRenderFns } from "./CourseBar.vue?vue&type=template&id=637a4464&scoped=true"
import script from "./CourseBar.vue?vue&type=script&lang=js"
export * from "./CourseBar.vue?vue&type=script&lang=js"
import style0 from "./CourseBar.vue?vue&type=style&index=0&id=637a4464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637a4464",
  null
  
)

export default component.exports